import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconUnarchive(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.707 2.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 5.414V11a1 1 0 1 0 2 0V5.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3Z"
        fill="currentColor"
      />
      <path
        d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1a1 1 0 1 0 0 2h1v5h-1.793a1.5 1.5 0 0 0-1.06.44L13.585 15h-3.172l-3.56-3.56A1.5 1.5 0 0 0 5.793 11H4V6h1a1 1 0 0 0 0-2H4a2 2 0 0 0-2 2v14Zm16.414-7H20v7H4v-7h1.586l3.56 3.56a1.5 1.5 0 0 0 1.061.44h3.586a1.5 1.5 0 0 0 1.06-.44L18.415 13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
